import ConversationsList from './ConversationsListContainer';

export default ConversationsList;
